// src/shared/modules/SliderModule.jsx
// Collection of PerlSlider components with subsection title

import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import PerlSlider from "../../shared/components/PerlSlider";
import { theme } from "../../design/theme";

const { perlColors } = theme.custom;

/**
 * SliderModule - Collection of sliders with a subsection title
 *
 * @param {Object} props
 * @param {String} props.title - Subsection title (e.g., "Process Parameters")
 * @param {Array} props.sliders - Array of slider configs: [{ key, label, value, min, max, step, unit, onChange }]
 * @param {Number} props.columns - Number of columns in grid (default: 4)
 */
export default function SliderModule({ title, sliders = [], columns = 4 }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="subtitle2"
        fontWeight={600}
        sx={{ mb: 2, color: perlColors.textPrimary }}
      >
        {title}
      </Typography>
      <Grid container spacing={2}>
        {sliders.map((slider) => (
          <Grid item xs={12} sm={6} md={12 / columns} key={slider.key} sx={{ minWidth: "250px" }}>
            <PerlSlider
              label={slider.label}
              value={slider.value}
              min={slider.min}
              max={slider.max}
              step={slider.step}
              unit={slider.unit}
              onChange={slider.onChange}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
